<svg width="40px" height="46px" viewBox="0 0 40 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>copy-all</title>
  <g id="Campaign-Management" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Copy-Items" transform="translate(-192.000000, -205.000000)" fill="#000000" fill-rule="nonzero">
      <g id="Modal" transform="translate(52.000000, 63.000000)">
        <g id="Campiagn-type-cell" transform="translate(79.000000, 102.000000)">
          <g id="copy-all" transform="translate(61.000000, 40.561404)">
            <path d="M0,45.3333333 L27.5010397,45.3333333 L27.5010397,12.592456 L0,12.592456 L0,45.3333333 Z M2.49986439,15.1105647 L25.0006328,15.1105647 L25.0006328,42.8143139 L2.49986439,42.8143139 L2.49986439,15.1105647 Z" id="Shape"></path>
            <polygon id="Path" points="7.4999548 8.81483758 31.2510171 8.81483758 31.2510171 37.7780965 33.7512431 37.7780965 33.7512431 6.29581817 7.49959318 6.29581817"></polygon>
            <polygon id="Path" points="13.7505198 1.94129169e-15 13.7505198 2.51901941 37.499774 2.51901941 37.499774 31.4813676 40 31.4813676 40 0"></polygon>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
